export function deleteTextNode(mutations: MutationRecord[]) {
  mutations.forEach((item) => {
    item.target.childNodes.forEach((child) => {
      if (child.nodeType === child.TEXT_NODE) {
        child.remove();
      }
    });
  });
}
